import React from 'react';
import UploadIcon from 'components/icons/UploadIcon';
import UploadTransactionsTable from 'components/Tables/UploadTransactionsTable';
import TransactionsLink from 'components/Links/TransactionsLink';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import Card from 'components/UIKit/Card';
import ExternalLink from 'components/Links/ExternalLink';
import UploadButton from 'components/buttons/UploadButton';

let styles = {
  topBullet: {
    textTransform: 'uppercase',
    fontSize: '1,3rem',
    marginLeft: '16px',
    fontWeight: 'bold',
  }
};

const UploadAndValidate = ({ router, project, list, workflow }) => (
  <Row style={{marginTop: '1rem'}}>
    <Column data-testid="table-upload-data" style={{flex: 3}}>
      <Row style={styles.topBullet}>1. Upload Data to your workspace</Row>
      <Card>
        <p style={{margin: '0 0 0.5rem'}}>
          Upload and validate your clinical, biospecimen and experimental
          data to the project workspace before data can be submitted to
          the GDC.
          <br />
          For additional instructions, please see the&nbsp;
          <ExternalLink href="https://docs.gdc.cancer.gov/Data_Submission_Portal/Users_Guide/Data_Submission_Walkthrough/">
            GDC Data Submission Portal User's Guide
          </ExternalLink>
        </p>

        <Row>
          <ol type="A">
            <li>
              Data must be compliant with the project dictionary.&nbsp;
              <ExternalLink href="https://docs.gdc.cancer.gov/Data_Dictionary/viewer/">
                View Dictionaries and Download Templates
              </ExternalLink>
            </li>
            <li>Data must be submitted in TSV or JSON format.</li>
            <li>Upload your TSV or JSON data files to the project workspace.</li>
          </ol>

          <Row style={{ alignSelf: 'flex-end', marginLeft: 'auto' }}>
            <UploadButton
              style={{ fontSize: '1.1rem', margin: '1rem' }}
              params={ router.params }
              location={ router.location }
              disabled={project.in_review || !project.submission_enabled || workflow.isFetching}
            >
              <UploadIcon /> UPLOAD
            </UploadButton>
          </Row>
        </Row>
        <Row style={{ margin: '15px -14px'}}>
          <UploadTransactionsTable
            router={router}
            projectInReview={project.in_review}
          >
            {list.data.items || []}
          </UploadTransactionsTable>
        </Row>
        <TransactionsLink query={{ type: 'upload' }}>
          View All Data Upload Transactions
        </TransactionsLink>
      </Card>
    </Column>
  </Row>
);

export default UploadAndValidate;
